module.exports = __webpack_public_path__ + "img/sites-ecommerces.8e5a592f.svg";